__turbopack_context__.v({
  "align_center": "RowHeader-module-scss-module__HKuglG__align_center",
  "align_start": "RowHeader-module-scss-module__HKuglG__align_start",
  "body_text": "RowHeader-module-scss-module__HKuglG__body_text",
  "content": "RowHeader-module-scss-module__HKuglG__content",
  "row_header_container": "RowHeader-module-scss-module__HKuglG__row_header_container",
  "title": "RowHeader-module-scss-module__HKuglG__title",
});
